import React from "react";
import CommonModal from "../CommonModal";
import "./UnapprovedNavigatorModal.css";

const UnpublishedShareModal = ({ onRepublishAndShare, onShareAnyway, onClose }) => (
  <CommonModal
    title="Your latest changes aren't published yet"
    modalStatus={true}
    changeActiveStatus={onClose}
    centered
    dialogClassName="unapproved-nav-dialog"
    footer={
      <div className="unapproved-nav__actions">
        <button type="button" className="unapproved-nav__primary" onClick={onRepublishAndShare}>
          Republish & share
        </button>
        <div className="unapproved-nav__secondary">
          <button type="button" className="unapproved-nav__link" onClick={onShareAnyway}>
            Share anyway
          </button>
          <button type="button" className="unapproved-nav__link" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    }
  >
    <p className="mb-0">
      You've edited this KDF since you last published it. If you share now, your recipients will see the
      last published version, not your latest changes.
    </p>
  </CommonModal>
);

export default UnpublishedShareModal;
